'use client'

import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
} from '@/components/extension/responsive-modal'
import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { Address } from '@/types/auth'
import { useTranslations } from 'next-intl'

interface CampaignAddressBookModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSelectAddress: (address: Address) => void
}

// Modal riêng cho luồng đăng ký campaign - chỉ liệt kê + chọn địa chỉ đã lưu
// để điền vào form giao hàng, không dùng chung với AddressBook ở trang cart.
export const CampaignAddressBookModal = ({
  open,
  onOpenChange,
  onSelectAddress,
}: CampaignAddressBookModalProps) => {
  const t = useTranslations('community_threads.campaign.address_book_modal')
  const { data: user } = useUserQuery()
  const addresses = user?.addresses ?? []

  const handleSelect = (address: Address) => {
    onSelectAddress(address)
    onOpenChange(false)
  }

  return (
    <ResponsiveModal open={open} onOpenChange={onOpenChange}>
      <ResponsiveModalContent
        className='gap-0 border-none px-5 py-6 lg:max-w-lg lg:p-8'
        aria-describedby='modal-campaign-address-book'
      >
        <ResponsiveModalTitle />
        <ResponsiveModalDescription />

        <h3 className='mb-4 font-criteria text-2xl font-bold text-neutral-900'>
          {t('title')}
        </h3>

        {addresses.length === 0 ? (
          <p className='text-sm text-neutral-500'>{t('empty')}</p>
        ) : (
          <ul className='no-scrollbar max-h-[60vh] space-y-3 overflow-y-auto'>
            {addresses.map((address) => (
              <li key={address._id}>
                <button
                  type='button'
                  onClick={() => handleSelect(address)}
                  className='relative w-full rounded-xl border border-neutral-200 px-4 py-3 text-left text-sm text-neutral-800 transition-colors hover:bg-neutral-100'
                >
                  {address.default && (
                    <span className='absolute right-3 top-3 text-xs text-primary'>
                      ★
                    </span>
                  )}
                  <p className='pr-6 font-medium text-neutral-900'>
                    {address.fullname} · {address.phone}
                  </p>
                  <p className='mt-1 text-neutral-600'>
                    {[
                      address.address,
                      address.ward,
                      address.district,
                      address.city,
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </p>
                </button>
              </li>
            ))}
          </ul>
        )}
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
